<script lang="ts">
    import { getTypedContext } from "@lib/svelte-typed-context";
    import { map } from "rxjs";

    import { containerQueryWidthContextToken } from "./context_tokens";

    type BreakpointKey = "sm" | "md" | "lg" | "xl";

    const BREAKPOINTS: Record<BreakpointKey, number> = {
        sm: 490, // 30.625rem
        md: 768, // 48rem
        lg: 1040, // 65rem
        xl: 1440, // 90rem
    };

    const width$ = getTypedContext(containerQueryWidthContextToken);

    $: breakpoints$ = width$.pipe(
        map((width) => ({
            width,
            smUp: width >= BREAKPOINTS.sm,
            mdUp: width >= BREAKPOINTS.md,
            lgUp: width >= BREAKPOINTS.lg,
            xlUp: width >= BREAKPOINTS.xl,
        }))
    );
</script>

<slot
    smUp={$breakpoints$?.smUp}
    mdUp={$breakpoints$?.mdUp}
    lgUp={$breakpoints$?.lgUp}
    xlUp={$breakpoints$?.xlUp}
    width={$breakpoints$?.width}
/>
